
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Sparkles, Edit3 } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { 
  sparkleAnimation, 
  glowingParticles 
} from './animations/contributionAnimations';

interface CustomAmountButtonProps {
  onClick: () => void;
}

const CustomAmountButton: React.FC<CustomAmountButtonProps> = ({ onClick }) => {
  const isMobile = useIsMobile();

  return (
    <motion.div
      variants={sparkleAnimation}
      animate="animate"
      whileTap={{ scale: 0.98 }}
      className="w-full relative overflow-hidden"
    >
      {/* Animated background particles */}
      <motion.div 
        className="absolute top-1/2 left-1/4 w-20 h-20 rounded-full bg-gradient-to-r from-blue-300 to-sky-300 bg-opacity-30 blur-xl"
        variants={glowingParticles}
        animate="animate"
      />
      <motion.div 
        className="absolute top-1/3 right-1/4 w-16 h-16 rounded-full bg-gradient-to-r from-blue-200 to-sky-400 bg-opacity-20 blur-xl"
        variants={glowingParticles}
        animate="animate"
        transition={{ delay: 0.5 }}
      />
      
      <Button
        type="button"
        className={`cheerful-button-hover flex items-center gap-2 w-full justify-center relative z-10
          ${isMobile ? 'py-3 text-sm' : 'py-5 text-base'} 
          bg-gradient-to-r from-blue-500 to-sky-500 hover:from-blue-600 hover:to-sky-600
          text-white font-medium rounded-md transition-all duration-300 shadow-md hover:shadow-lg
          border border-blue-400`}
        onClick={onClick}
      >
        <Sparkles size={isMobile ? 18 : 20} className="animate-pulse text-blue-100" />
        <span className="font-medium">{isMobile ? 'Đóng góp tuỳ chọn' : 'Nhập số tiền đóng góp theo ý muốn'}</span>
        <Edit3 size={isMobile ? 16 : 18} className="text-blue-100" />
      </Button>
    </motion.div>
  );
};

export default CustomAmountButton;
